function init_summergame(from_php){
    
    
    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }
    var main=$(".place.summergame");
    var semaphoreSuit= new mySemaphore();
    var afterLoad=new afterInit();

    var girl_id=intval(from_php.girl_id);

    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex(),
        "loader":_moduleTimeHandler.getNewIndex(),
        "counter":_moduleTimeHandler.getNewIndex(),
        "hide_smoke":_moduleTimeHandler.getNewIndex()
    };

    var girl_name=$.takeGirlImage(girl_id);
    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var gameLog=[];
    var secureStr=from_php.secure;
    var book=main.find("#bookGameJS");




    var gameCanv=main.find("#canvMain");

    var girlCtx=main.find("#girlWrap canvas.qgirl")[0];
    girlCtx=girlCtx.getContext("2d");


    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
    function quickPreloader(){
        var radius=0,dir_rot=2,dir=1,step=0,obj=main.find(".formSubmit.butLoader.soccer"),
            circleObj=obj.find(".img"),textObj=obj.find(".in"),step_mig=20;
        _moduleTimeHandler.set(timeIndexArr.loader,function(){
            radius=(radius+dir_rot)%360;
            step+=dir;
            circleObj.cssrotate(radius);
            if(step%step_mig<step_mig/2){
                textObj.addClass("hide");
            }
            else{
                textObj.removeClass("hide");
            }
        },50);
    }
    quickPreloader();


    main.find(".bookGameIns").on("close",function(){
        main.find(".bookGame").bookUse("show");
        return false;
    });

    function postAjax(to_send,refuse_response,on_end){
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"summergame"};
            data_send=$.extend(data_send,to_send);
            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                    if(intval(data.level)>intval(from_php.level)){
//                        _mySound.playSound("girl_smile");
                    }
                    if(intval(data.was_ended)>intval(from_php.was_ended)){
                        _mySound.playSound("girl_moan");
                        $.goToLocation("summeranim/"+girl_id+"/1/");
                        return false;
                    }
                    from_php=$.extend(from_php,data);
                    function isEnd(){
                        if(!refuse_response){
                            updateState();
                        }
                        if(typeof on_end=="function"){
                            on_end();
                        }
                    }
                    if(data_send.wait){
                        _moduleTimeHandler.setOne(timeIndexArr.ajax,function(){
                            isEnd();
                        },1500);
                    }
                    else{
                        isEnd();
                    }

                }
                semaphoreSuit.clear();
            },"json");
        }
    }
    function showFace(state,text_smoke){
        var wrap=main.find("#girlWrap");
        if(wrap.attr("data-state")==state){
            return false;
        }
        wrap.attr("data-state",state);
        var face={
            "happy":{path: _IMG_SERV+"/gfx/place/summergame/girls/"+girl_name+"/ready/i.png",pref:"i"},
            "scared":{path: _IMG_SERV+"/gfx/place/summergame/girls/"+girl_name+"/ready/s.png",pref:"s"},
            "normal":{path: _IMG_SERV+"/gfx/place/summergame/girls/"+girl_name+"/ready/n.png",pref:"n"}
        };
        var pos_conf={
            "1":{i:{left:670,top:91},n:{left:670,top:91},s:{left:670,top:91}},
            "2":{i:{left:667,top:144},n:{left:667,top:145},s:{left:667,top:145}},
            "3":{i:{left:707,top:126},n:{left:706,top:125},s:{left:707,top:125}},
            "4":{i:{left:671,top:204},n:{left:671,top:205},s:{left:671,top:205}},
            "5":{i:{left:681,top:185},n:{left:681,top:185},s:{left:681,top:186}},
            "6":{i:{left:689,top:179},n:{left:689,top:179},s:{left:689,top:178}},
            "7":{i:{left:642,top:132},n:{left:642,top:132},s:{left:642,top:131}},
            "8":{i:{left:672,top:179},n:{left:672,top:179},s:{left:671,top:182}},
            "9":{i:{left:671,top:130},n:{left:671,top:130},s:{left:671,top:130}},
            "10":{i:{left:693,top:212},n:{left:693,top:212},s:{left:693,top:212}},
            "11":{i:{left:650,top:124},n:{left:650,top:124},s:{left:650,top:125}},
            "12":{i:{left:642,top:128},n:{left:643,top:127},s:{left:642,top:128}},
            "13":{i:{left:687,top:224},n:{left:688,top:223},s:{left:687,top:223}},
            "14":{i:{left:654,top:233},n:{left:653,top:233},s:{left:653,top:233}},
            "15":{i:{left:696,top:147},n:{left:696,top:146},s:{left:695,top:146}},
            "16":{i:{left:680,top:108},n:{left:681,top:108},s:{left:680,top:108}},
            "17":{i:{left:642,top:230},n:{left:642,top:231},s:{left:643,top:231}},
            "18":{i:{left:708,top:105},n:{left:709,top:105},s:{left:709,top:106}},
            "19":{i:{left:709,top:117},n:{left:709,top:117},s:{left:709,top:117}}
        };

        var pos=pos_conf[from_php.girl_id][face[state].pref];

        var img=new Image();
        img.onload=function(){
            girlCtx.clearRect(0, 0, 1280, 780);
            girlCtx.drawImage(img,pos.left, pos.top);
            wrap.find(".qbody").remove();
        };
        img.src=face[state].path;

        var smokeGirl=main.find("#textScaredGirlJS");
        if(text_smoke){
            _moduleTimeHandler.clear(timeIndexArr.hide_smoke);
            smokeGirl.fadeIn(400);//removeClass("hide").css({opacity:1,dislay:"block"});
            smokeGirl.find(".wrap").html(
                "<div class='textfill center'>"+
                "<span>"+text_smoke+"</span>"+
                "</div>"
            );
            smokeGirl.find(".textfill").textfill();
            _moduleTimeHandler.setOne(timeIndexArr.hide_smoke,function(){
                smokeGirl.fadeOut(300);
            },5000);
        }
        else{
            smokeGirl.fadeOut(300);
        }

        //scared_text

    }
    function updateState(){
        if(from_php.was_error){
            showState("wrong");
        }
        else if(from_php.time_game){
            showState("game");
        }
        else{
            if(from_php.was_paid==0){
                if(from_php.try_count>0){
                    postAjax({prepare_init:1});
                }
                else{
                    showState("need_try");
                }
            }
            else if(from_php.was_shown==0 && from_php.level_show>0){
                showState("next");
            }
            else{
                if(from_php.level_show == 0){
                    showState("init");
                } else {
                    showState("game_init");
                }
            }
        }
        main.attr("data-level",(intval(from_php.level_show)+1))
        main.find(".repeatMoveTriggerJS .in").html("x"+from_php.repeat_count);
    }


    function init(){
//        main.find(".butNextLevelStartJS").click(function(){
//            _mySound.playSound("button_click");
//            postAjax({prepare_init:1});
//        });
        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                //postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            postAjax({buy_repeat:1});

            main.find(".repeatCountCrab .krabek").eq(0).remove();
        });

        var repeat_count = intval(from_php.repeat_count),repeatObj = $("<div />");
        if(repeat_count>0){
            repeatObj.addClass("repeatCountCrab");
            for (var i=0;repeat_count>i;i++) {
                repeatObj.prepend("<div class='krabek'></div>");
            }
        }

        main.find("#canvWrapAll").append(repeatObj);

        updateState();
    }


    var stateFun={
        "wrong":function(){
            if(from_php.level_show>0){
                main.find(".repeatMoveJS").show();
            }
            else{
                main.find(".repeatMoveJS").hide();
            }
            main.find("#failReasonJS").html(from_php.langs["fail"+from_php.was_error]);
        },
        "init":function(){
            book.bookUse("show");
            main.find(".gameStartJS").one("click",function(){
                showState("game_init");
            });
        },
        "need_try":function(){

        },
        "next":function(){
            main.find(".putGameJs[data-type='level']").html(intval(from_php.level_show)+1);
        },
        "game_init":function(){
            initGame();
            gameCover.addClass("hide");
            main.find(".bookGameIns[g_id='11']").bookUse("hide");
            book.bookUse("hide");
        },
        "game":function(){
            gameCover.addClass("hide");
            main.find(".hideOnGameJS").addClass("hide");
            main.find(".showOnGameJS").removeClass("hide");
        }
    };
    function showState(state){
        if(state_cur==state){
            return false;
        }
        var hide_show=main.find("#girlWrap,#bagCover");
        if(state=="init"){
            hide_show.hide();
        }
        else{
            hide_show.show();
        }



        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.summergame .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);

        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }

        state_cur=state;

        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");

        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        stateFun[state]();
        gameCoverWin.find(".textfill").textfill();

    }



    init();




    function initGame(){
        var obj=main.find("#canvMain");





        var curTextObj={},curTextArr=[];
        var animIndex={
            eye:_moduleTimeHandler.getNewIndex(),
            mouth:_moduleTimeHandler.getNewIndex(),
            extra:_moduleTimeHandler.getNewIndex()
        };

        function getNextWholeText(textArrAll){
            function prepareMouthAnim(){
//            var step=1,dir=1,step_max=girlConf["mouth"]
//            ,obj=win.find(".girlParts .m");
//            _moduleTimeHandler.clear(animIndex.mouth);
//            _moduleTimeHandler.set(animIndex.mouth,function(){
//                step+=dir;
//                if(step==step_max){
//                    dir=-1;
//                }
//                if(step==1){
//                    dir=1;
//                }
//                obj.attr("data-step",step);
//            },150,function(){
//               obj.attr("data-step",0);
//            });
            }
            function calculateWordDimensions(text, classes) {
                classes = classes || [];


                classes.push('textDimensionCalculation');

                var div = document.createElement('div');
                div.setAttribute('class', classes.join(' '));

                $(div).text(text);

                main[0].appendChild(div);

                var dimensions = {
                    width : $(div).outerWidth(),
                    height : $(div).outerHeight()
                };

                div.parentNode.removeChild(div);

                return dimensions;
            };



            curTextObj=textArrAll.shift();
            main.find(".sayBox").removeClass("hide");
            main.find(".sayBoxJS").hide().filter("[data-type='"+curTextObj.type+"']").show();
            var textArr=curTextObj.text.split(" "),textTmp=[],i;
            var textObjField=main.find(".contentSayJS");
            var textHeight=textObjField.height();
            while(textArr.length>0){
                textTmp=[];
                for(i=0;i<10;i++){
                    textTmp.push(textArr.shift());
                }
                while(textArr.length>0 && calculateWordDimensions(textTmp.join(" "),["textForSayClass"]).height<=textHeight){
                    textTmp.push(textArr.shift());
                }
                if(calculateWordDimensions(textTmp.join(" "),["textForSayClass"]).height>textHeight){
                    textArr.unshift(textTmp.pop());
                }
                curTextArr.push(textTmp.join(" "));
            }
            function nextStep(){
                textObjField.off("lBl_end,lBl_start").one("lBl_start",function(){
                    if(curTextObj.type=="girl"){
                        prepareMouthAnim();
                    }
                }).on("lBl_end",function(){
                    _moduleTimeHandler.clear(animIndex["mouth"]);
                }).letterByletter({letterTime:40,text:curTextArr.shift()},_moduleTimeHandler);
                main.find(".sayBox").trigger("nextStep");
            }

            nextStep();
            main.find(".nextTextJS").off("click.nextGN").on("click.nextGN",function(){
                if(textObjField.letterByletter("isEnd")==1){
                    if(curTextArr.length>0){
                        nextStep();
                        _mySound.playSound("page_selector");
                    }
                    else if(from_php.dialog.length>0){
                        getNextWholeText(from_php.dialog);
                    }
                    else{
                        startGame();
                        main.find(".sayBox").addClass("hide");
                        main.find(".nextTextJS").off("click.nextGN");
                    }
                }
                else{
                    _mySound.playSound("page_selector");
                    textObjField.letterByletter("clear");
                }
            });
        }


        function showLives(){
            var obj=main.find("#readyJS");
            var state=gameCanv.summerGame("takeGameState");
            var i,k,gift_html="",gift_id,have_it;
            for(i in state.gift_need){
                gift_id=state.gift_need[i];
                have_it=0;
                for(k=state.gift_have.length-1;k>=0;k--){
                    if(state.gift_have[k]==gift_id){
                        have_it=1;
                        state.gift_have.splice(k,1);
                        break;
                    }
                }
                gift_html+='<div class="cell" data-have_it="'+have_it+'">'+
                    '<div class="img" style="background-image:url('+_IMG_SERV+'/gfx/place/summergame/crab_items/'+gift_id+'.png)"></div>'+
                    '</div>';
            }
            obj.find(".wrapGifts").html(gift_html);
            var live_html="";
            for(i=0;i<state.live_max;i++){
                have_it=0;
                if(i<state.live){
                    have_it=1;
                }
                live_html+='<div class="cell" data-have_it="'+have_it+'">'+
                    '<div class="img"></div>'+
                    '</div>';
            }
            obj.find(".wrapLives").html(live_html);

        }

        function startGame(){
            var canChooseCrab=0;
            postAjax({start_game:1});
            main.find(".bookGameIns.book").off("close").bookUse("hide");

            main.find(".hideOnGameJS").addClass("hide");
            book.bookUse("hide");

            showLives();
            var startCounter=4,counterObj=main.find("#qCounter");
            var howlong=10,howlong_str=howlong;
            if(howlong<10){
                howlong_str="0"+howlong;
            }
            main.find(".timerInGameJS").html("00:"+howlong_str);
            gameCanv.on("myCounter",function(){
                startCounter--;
                var opacity,step=0,step_max=10;
                counterObj.html(startCounter).css("opacity",1).removeClass("hide");
                if(startCounter==1){
                    showFace("normal");
                }
                _moduleTimeHandler.set(timeIndexArr.counter,function(){
                    opacity=Math.max(0,1-step/step_max);
                    step++;
                    if(opacity==0){
                        _moduleTimeHandler.clear(timeIndexArr.counter);
                        counterObj.addClass("hide");
                    }
                    counterObj.css("opacity",opacity);
                },50);
            }).one("crabReady",function(){
                canChooseCrab=1;
                _timerManager.addTimer(".place.summergame .timerInGameJS",getCurrentTime()+howlong,1,function(){
                    gameCanv.summerGame("runCrabs");
                    postAjax({was_error:2});
                    canChooseCrab=0;
                    obj.summerGame("markCrab",[0,0]);
                });
            }).on("qface",function(e,val){
                var text="";
                if(val=="scared"){
                    text=from_php.scared_text;
                }
                showFace(val,text);
            });

            gameCanv.summerGame("start");
            gameCanv.click(function(e){
                var pos=[$.getXeventOffset(e),$.getYeventOffset(e)];
                var res=obj.summerGame("clickCrab",pos);
                if(res.fail){
                    if(res.lose){
                        showFace("scared");
                        _timerManager.deleteTimer(".place.summergame .timerInGameJS");
                        _moduleTimeHandler.addOne(function(){
                            postAjax({was_error:1});
                        },4000);
                    }
                }
                else if(res.win){
                    _timerManager.deleteTimer(".place.summergame .timerInGameJS");
                    _moduleTimeHandler.addOne(function(){
                        postAjax({game_conf:(Base64.encode(secureStr))});
                    },3000);
                }
                showLives();
                e.preventDefault();
            }).on("touchmove mousemove",function(e){
                if(canChooseCrab){
                    var pos=[$.getXeventOffset(e),$.getYeventOffset(e)];
                    obj.summerGame("markCrab",pos);
                }
            });

        }

        afterLoad.addFun(function(){
            if(from_php.level_show==0 && from_php.dialog.length){
                getNextWholeText(from_php.dialog);
            }
            else{
                startGame();
            }

        });

    }
    function wasLoaded(){
        main.find(".gameIsLoadingJS").addClass("hide");
        main.find(".gameIsLoadedJS").removeClass("hide");
        _moduleTimeHandler.clear(timeIndexArr.loader);
        afterLoad.load();
    }
    function prepareBagConf(){
        var bag_conf=[
            [992,630],
            [1012,497],
            [1048,426],
            [1114,451],
            [1126,520]
        ];
        var bag_conf_force={
            "1":[[777,446],[791,402],[831,346],[916,330],[964,402]],
            "2":[[910,427],[912,343],[1000,295],[1072,333],[1064,377]],
            "3":[[784,463],[809,402],[880,379],[942,413],[966,457]],
            "4":[[811,462],[844,393],[914,351],[990,378],[1032,457]],
            "5":[[811,462],[838,400],[879,351],[973,381],[988,474]],
            "6":[[782,462],[816,395],[863,344],[965,376],[982,452]],
            "7":[[811,462],[830,404],[883,268],[983,335],[992,389]],
            "8":[[811,462],[838,398],[861,303],[970,355],[979,399]],
            "9":[[770,442],[791,364],[855,290],[929,332],[943,382]],
            "10":[[806,438],[838,353],[925,316],[965,369],[969,410]],
            "11":[[787,444],[816,364],[927,332],[970,370],[980,412]],
            "12":[[793,459],[830,354],[903,260],[981,316],[1000,386]],
            "13":[[831,446],[852,337],[929,270],[985,312],[997,377]],
            "14":[[819,397],[833,318],[911,259],[980,305],[980,355]],
            "15":[[839,437],[872,355],[954,282],[1015,354],[1028,388]],
            "16":[[830,442],[857,374],[895,296],[982,309],[985,362]],
            "17":[[852,444],[859,360],[898,273],[984,305],[985,373]],
            "18":[[836,451],[865,350],[934,253],[1025,293],[1025,377]],
            "19":[[700,508],[757,418],[869,373],[918,428],[917,473]]
        };
        if(typeof bag_conf_force[from_php.girl_id]!="undefined"){
            bag_conf=bag_conf_force[from_php.girl_id];
            var i,bum;
            for(i in bag_conf){
                bag_conf[i][0]+=85;
                bag_conf[i][1]+=95;
            }

        }
        return bag_conf;
    }
//    from_php.level=1;
    if(_ON_DEV){
//        from_php.level=Math.max(from_php.level,5);
    }
    gameCanv.one("was_loaded",function(){
        $("<div/>").one("myload",function(){
            showFace("normal");
            main.find("#girlWrap .eye.eyeJS").myEye({});
            wasLoaded();

        }).myLoad([
            _IMG_SERV+"/gfx/place/summergame/girls/"+girl_name+"/ready/i.png",
            _IMG_SERV+"/gfx/place/summergame/girls/"+girl_name+"/ready/s.png",
            _IMG_SERV+"/gfx/place/summergame/girls/"+girl_name+"/ready/n.png",
            _IMG_SERV+"/gfx/place/summergame/girls/"+girl_name+"/ready/eye2.png",
            _IMG_SERV+"/gfx/place/summergame/girls/"+girl_name+"/ready/eye1.png",
        ]);

    }).summerGame({conf_bag:prepareBagConf(),level:from_php.level,hard:from_php.win_times},_moduleTimeHandler);


//    if(_ON_DEV){
//        showState("game_init");
//    }

    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
}

